"use client";

import { useSyncExternalStore } from "react";

// Open state of the off-canvas sidebar drawer below `lg`. A tiny module store because
// the hamburger (Navbar) and the drawer (Sidebar) are siblings in the server layout.
let open = false;
const subs = new Set<() => void>();

export function setMobileNavOpen(v: boolean) {
  if (open === v) return;
  open = v;
  subs.forEach((f) => f());
}

export const isMobileNavOpen = () => open;
export function subscribeMobileNav(f: () => void) {
  subs.add(f);
  return () => {
    subs.delete(f);
  };
}

export function useMobileNavOpen() {
  return useSyncExternalStore(subscribeMobileNav, isMobileNavOpen, () => false);
}
